module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_clubs-3.1e3176b3.svg";